import { Input, type InputProps } from '@eombor/ui';
import { UZ_CALLING_CODE, formatUzNational, uzNationalDigits } from '@eombor/contracts';

export interface PhoneInputProps
  extends Omit<InputProps, 'value' | 'onChange' | 'prefix' | 'type' | 'children'> {
  /** FAQAT milliy qism — ko'pi bilan 9 ta raqam, ajratgichsiz. */
  value: string;
  onChange: (digits: string) => void;
}

/**
 * TELEFON RAQAMI maydoni — `+998` yozilmaydi, u o'zi turadi.
 *
 * Tizimdagi hamma raqam bir xil ko'rinishda: mamlakat kodi, ikki xonali
 * operator kodi va yetti xona. Shuning uchun kodni har safar qo'lda terish
 * — bekorga bosilgan to'rt tugma va xato qilishning ortiqcha imkoni: odam
 * uni goh `+998`, goh `998`, goh umuman yozmay ketardi va bazada bitta
 * raqam uch xil yozuvda yotardi.
 *
 * Kod maydonning ICHIDA emas, yonida turadi: u matnning bir qismi bo'lsa,
 * o'chirib yuborish yoki uning ustiga yozib yuborish mumkin bo'lardi.
 * Holatda esa faqat 9 xona saqlanadi — ajratgichlar chiqarishda qo'shiladi,
 * shuning uchun "90 123-45-67" va "901234567" farqi umuman tug'ilmaydi.
 *
 * Terilayotgan matn har bosishda qaytadan tuziladi (`uzNationalDigits` →
 * `formatUzNational`), ya'ni nusxa-ko'chirilgan `+998 90 123-45-67` ham,
 * `998901234567` ham bir xil natija beradi.
 */
export const PhoneInput = ({ value, onChange, ...rest }: PhoneInputProps) => (
  <Input
    {...rest}
    type="tel"
    inputMode="numeric"
    autoComplete="tel-national"
    mono
    /* `Input` prefiksni xira rangda beradi — u yerda prefiks odatda
       ikona, ya'ni bezak. Bu yerda esa kod HAQIQIY qiymat: namuna
       matni bilan bir rangda bo'lsa, maydon bo'sh bo'lib ko'rinardi. */
    prefix={<span className="text-text tabular">+{UZ_CALLING_CODE}</span>}
    /* Prefiks `Input` da mutlaq joylashgan va u ikona kengligiga
       (`pl-9`) mo'ljallangan. "+998" undan kengroq, shuning uchun bo'shliq
       shu yerda o'lchanadi — aks holda kod bilan raqam ustma-ust tushadi. */
    style={{ paddingInlineStart: '3.75rem' }}
    value={formatUzNational(value)}
    onChange={(event) => onChange(uzNationalDigits(event.target.value))}
  />
);
